import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { usePopupState, bindTrigger, bindMenu } from "material-ui-popup-state/hooks";

const styles = {
  mainButton: {
    mr: "1px",
    height: 36,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },
  dropdownButton: {
    px: 0,
    height: 36,
    minWidth: 36,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },
};

export default function ScanActions({ onScan, onManualSearch, onMoveEmptyMobileLocation }) {
  const popupState = usePopupState({ variant: "popover", popupId: "scan-options-menu" });

  const handleManualSearch = () => {
    onManualSearch();
    popupState.close();
  };

  const handleMoveEmptyMobileLocation = () => {
    onMoveEmptyMobileLocation();
    popupState.close();
  };

  return (
    <Box display="flex">
      <Button
        variant="contained"
        color="primary"
        onClick={onScan}
        size="large"
        sx={styles.mainButton}
      >
        Scan to Begin
      </Button>
      <Button
        size="large"
        variant="contained"
        color="primary"
        sx={styles.dropdownButton}
        {...bindTrigger(popupState)}
      >
        <KeyboardArrowDownIcon
          sx={{ transform: popupState.isOpen ? "rotate(180deg)" : undefined }}
        />
      </Button>
      <Menu {...bindMenu(popupState)}>
        <MenuItem onClick={handleManualSearch}>Enter Barcode Manually</MenuItem>
        <MenuItem onClick={handleMoveEmptyMobileLocation}>Move Empty Mobile Location</MenuItem>
      </Menu>
    </Box>
  );
}